import request from '../../utils/requests'

/**
 * Tag: NoticeManage
 */

const baseUrl ="/api/NoticeManage";



/**
 * 获取学员信息
 * @param {*} body
 * {
 *    NameOrPhone Desc:名称或手机号 Required:false
 *    ClassId Desc:班级ID集合 Required:false
 *    CourseId Desc:课程ID集合 Required:false
 *    TeacherList Desc:老师 Required:false
 *    AssistantList Desc:助教 Required:false
 *    OrgId Desc:机构Id(传值0) Required:false
 *    BranchId Desc:校区ID Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getStudentPaging(body) {
  return request(baseUrl+'/getStudentPaging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 新增/更新
 * @param {*} body
 * {
 *    NoticeId Desc: Required:false
 *    NoticeTemplateId Desc:通知模板 Required:false
 *    NoticeTitle Desc:标题 Required:false
 *    NoticeContent Desc: Required:false
 *    IsReceipt Desc:是否回执 Required:false
 *    NoticeState Desc:状态（0：草稿；1：已发布） Required:false
 *    BranchId Desc:校区Id 机构时校区Id=0 Required:false
 *    NoticeMessages Desc:发送对象 Required:false
 * }
 */
async function _addOrUpdate(body) {
  return request(baseUrl+'/addOrUpdate',{
    method: 'POST',
    body: body,
  });

}



/**
 * 获取详情
 * @param {*} param
 * {
 *    NoticeId Desc: Required:true
 * }
 */
async function _getModel(param) {
  return request(baseUrl+'/getModel',{
    method: 'GET',
    params: param,
  });

}



/**
 * 删除
 * @param {*} param
 * {
 *    NoticeId Desc: Required:true
 * }
 */
async function _deleteByID(param) {
  return request(baseUrl+'/deleteByID',{
    method: 'GET',
    params: param,
  });

}



/**
 * 批量删除
 * @param {*} body
 * {
 *    NoticeIds Desc: Required:false
 * }
 */
async function _deleteByIDs(body) {
  return request(baseUrl+'/deleteByIDs',{
    method: 'POST',
    body: body,
  });

}



/**
 * 分页
 * @param {*} body
 * {
 *    NoticeTitle Desc:标题 Required:false
 *    CreateName Desc:创建人 Required:false
 *    NoticeState Desc:状态（0：草稿；1：已发布） Required:false
 *    PublishedStartTime Desc:开始日期 Required:false
 *    PublishedEndTime Desc:结束日期 Required:false
 *    OrgId Desc:机构Id(传值0) Required:false
 *    BranchId Desc:校区ID Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getNoticePing(body) {
  return request(baseUrl+'/getNoticePing',{
    method: 'POST',
    body: body,
  });

}



/**
 * 发送人员名单（分页）
 * @param {*} body
 * {
 *    NoticeId Desc:通知主键 Required:false
 *    NameOrPhone Desc:名称或手机号 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getNoticeMessagePing(body) {
  return request(baseUrl+'/getNoticeMessagePing',{
    method: 'POST',
    body: body,
  });

}



/**
 * 通知模板分页
 * @param {*} body
 * {
 *    Name Desc:模板名称 Required:false
 *    Start Desc:开始行数 从0开始 Required:false
 *    Length Desc:页面大小 Required:false
 *    End Desc:结束行数 Required:false
 * }
 */
async function _getNoticeTemplatePaging(body) {
  return request(baseUrl+'/getNoticeTemplatePaging',{
    method: 'POST',
    body: body,
  });

}



/**
 * 通知模板：GetModel
 * @param {*} param
 * {
 *    id Desc: Required:true
 * }
 */
async function _getNoticeTemplateModel(param) {
  return request(baseUrl+'/getNoticeTemplateModel',{
    method: 'GET',
    params: param,
  });

}



export default{
  _getStudentPaging,
  _addOrUpdate,
  _getModel,
  _deleteByID,
  _deleteByIDs,
  _getNoticePing,
  _getNoticeMessagePing,
  _getNoticeTemplatePaging,
  _getNoticeTemplateModel
}




// WEBPACK FOOTER //
// ./src/services/noticeManage.js